import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import {useState} from "react";
import Fab from "@mui/material/Fab";

export default function DongMenuButton(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sido, setSido] = useState(["삭제","서울특별시","경기도","부산광역시","울산광역시","강원특별자치도","충청북도","충청남도",
        "경상북도","경상남도","세종특별자치시","대전광역시","전라북도","전라남도","광주광역시","제주특별자치도"])
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleGetData = (x) => {
        props.getData(x.target.outerText)
        setAnchorEl(null);
    }
    return (
        <React.Fragment >
            <Fab size="small" onClick={handleClick}>
                동
            </Fab>

            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        color:'white'
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {sido.map(x=>{
                    return (
                        <MenuItem key={x} onClick={handleGetData}>
                            {x}
                        </MenuItem>
                    )

                })}


            </Menu>
        </React.Fragment>
    );
}